var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signed-contracts container container_30" },
    [
      _c(
        "div",
        { staticClass: "signed-contracts__header" },
        [
          _c("searcher", {
            on: { "compose-filters": _vm.loadFilteredContracts }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "signed-contracts__dispute-filter" },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.filters.isDisputing,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "isDisputing", $$v)
                    },
                    expression: "filters.isDisputing"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.i18n.cont_show_active_disputes()) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "signed-contracts__table" },
        [
          _vm.list.length
            ? [
                _c(
                  "md-table-row",
                  { staticClass: "signed-contracts_row" },
                  [
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_counterparty()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_contract_number()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_start_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_end_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_active_disputes()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head")
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, i) {
                  return [
                    _c(
                      "md-table-row",
                      { key: i, staticClass: "signed-contracts__row" },
                      [
                        _c(
                          "md-table-cell",
                          {
                            staticClass:
                              "signed-contracts__table-cell counterparty-cell"
                          },
                          [
                            _c("company-name-getter", {
                              attrs: { id: item.contractor }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "signed-contracts__table-cell" },
                          [_vm._v(_vm._s(item.contractNumber))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "signed-contracts__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.d(item.startDate)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "signed-contracts__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.d(item.endDate)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "signed-contracts__table-cell" },
                          [
                            _vm._v(
                              _vm._s(
                                item.isDisputing
                                  ? _vm.i18n.lbl_yes()
                                  : _vm.i18n.lbl_no()
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "signed-contracts__table-cell" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "signed-contracts__view-details-btn md-icon-button",
                                on: {
                                  click: function($event) {
                                    return _vm.openDetails(item.id)
                                  }
                                }
                              },
                              [_c("md-icon", [_vm._v("keyboard_arrow_right")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }),
                _vm._v(" "),
                !_vm.isLoaded
                  ? _c(
                      "md-table-row",
                      [
                        _c("md-table-cell", { attrs: { colspan: "7" } }, [
                          _c(
                            "div",
                            { staticClass: "signed-contracts__btn-outer" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-primary",
                                  attrs: { disabled: _vm.isLoading },
                                  on: { click: _vm.more }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_view_more()))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "signed-contracts__no-contracts" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_signed_contracts()))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_signed_contracts_desc()))
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a689b5a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a689b5a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/signed/Contracts.SignedList.vue
// module id = LE+h
// module chunks = 1